import { RouterModule, Routes } from '@angular/router';

import { NopagefoundComponent } from './shared/nopagefound/nopagefound.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { PagesComponent } from './pages/pages.component';
import { LoginComponent } from './login';



const appRoutes: Routes = [
    { path: 'login', component: LoginComponent },    
    { path: '**', component: NopagefoundComponent }

];


export const APP_ROUTES = RouterModule.forRoot(appRoutes, { useHash: true });
